export default __webpack_public_path__ + "static/webRotator/svg/2fb5133ec398aa6bdab5b264f0f7323d.svg";